module.exports = __webpack_public_path__ + "static/img/sms-footer.367076d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sms-footer.png
// module id = 2FGA
// module chunks = 0